import type { recipeIngredient } from '../../../../utils/recipeUtils'
import { useState } from 'react'

import './RecipeIngredient.scss'

interface RecipeIngredientProps {
  index: number
  ingredient: recipeIngredient
  setRecipeIngredient: (index: number, newIngredient: recipeIngredient) => void
}
function RecipeIngredient({
  index,
  ingredient,
  setRecipeIngredient,
}: RecipeIngredientProps) {
  const [extra, setExtra] = useState<string | null>(ingredient.extra)
  const [quantity, setQuantity] = useState<number>(ingredient.quantity)

  const handleIngredientQuantityChange = (newQuantity: number) => {
    setQuantity(newQuantity)
    handleIngredientChange(newQuantity, extra ?? '')
  }

  const handleIngredientExtraChange = (newExtra: string) => {
    setExtra(newExtra)
    handleIngredientChange(quantity, newExtra)
  }

  const checkIngredientChanged = (newQuantity: number, newExtra: string) => {
    return newQuantity !== quantity || newExtra !== (extra ?? '')
  }

  const handleIngredientChange = (newQuantity: number, newExtra: string) => {
    if (checkIngredientChanged(newQuantity, newExtra)) {
      const newIngredient: recipeIngredient = {
        ...ingredient,
        quantity: newQuantity,
        extra: newExtra.trim() === '' ? null : newExtra.trim(),
        modified: true,
      }
      setRecipeIngredient(index, newIngredient)
    }
  }

  const handleDelete = () => {
    const newIngredient: recipeIngredient = { ...ingredient, deleted: true }
    setRecipeIngredient(index, newIngredient)
  }

  return (
    <div className="recipe-list-item">
      <span className="recipe-ingredient-product">
        {ingredient.productName}
      </span>
      <div className="recipe-ingredient-qty-container">
        <span className="recipe-ingredient-quantity-x">{'x'}</span>
        <input
          type="number"
          className="recipe-ingredient-quantity"
          defaultValue={quantity}
          onChange={e => handleIngredientQuantityChange(Number(e.target.value))}
        />
      </div>
      <input
        type="text"
        className="recipe-ingredient-extra"
        defaultValue={extra ?? ''}
        onChange={e => handleIngredientExtraChange(e.target.value)}
      />
      <button
        className="recipe-ingredient-delete-button"
        onClick={handleDelete}
      >
        ×
      </button>
    </div>
  )
}

export default RecipeIngredient
